import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { SensorDataFileStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const defaultFilter = {
  page: 0,
  limit: 50,
  search: "",
};

export const initialState: SensorDataFileStateType = {
  files: [],
  filesTotal: 0,
  filter: { ...defaultFilter },

  file_perscentage: 0,
  uploaded_file: null,
  current_file: null,
  current_file_values: [],
  current_file_values_filter: null,
};

const reducer = createReducer<SensorDataFileStateType, Action>(initialState)
  .handleAction(actions.getSensorDataFiles.success, (state, action) =>
    produce(state, (nextState) => {
      const { rows, count, is_clear } = action.payload;
      nextState.files = !is_clear ? [...nextState.files, ...rows] : [...rows];
      nextState.filesTotal = count;
    }),
  )
  .handleAction(actions.setFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.filter = action.payload || { ...defaultFilter };
    }),
  )
  .handleAction(actions.setCurrentFileValuesFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.current_file_values_filter = action.payload;
    }),
  )
  .handleAction(actions.clearSensorDataFiles, (state) =>
    produce(state, (nextState) => {
      nextState.files = [];
      nextState.filesTotal = 0;
    }),
  )
  .handleAction(actions.createSensorDataFile.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.uploaded_file = action.payload;
      nextState.files = [action.payload, ...nextState.files];
    }),
  )
  .handleAction(actions.clearSensorDataFile, (state) =>
    produce(state, (nextState) => {
      nextState.uploaded_file = null;
    }),
  )
  .handleAction(actions.getSensorDataFile.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.current_file = action.payload;
    }),
  )
  .handleAction(actions.getSensorDataFileValues.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.current_file_values = action.payload.rows;
    }),
  )
  .handleAction(actions.setFilePercentage, (state, action) =>
    produce(state, (nextState) => {
      nextState.file_perscentage = action.payload;
    }),
  );

export { reducer as SensorDatafileReducer };
